const strHelper = () => {
	/**
	 * 字符串去空格
	 * @param  {string} str 原字符串
	 * @return {string}	 取空格后的结果
	 */
	let trim = (str) => {
		return str.replace(/(^\s*)|(\s*$)/g, '')
	}

	let pad = (str, totalWidth, paddingChar, isRightPadded) => {
		if (str.length < totalWidth) {
			var paddingString = ''
			for (var i = 1; i <= (totalWidth - str.length); i++) {
				paddingString += paddingChar
			}

			if (isRightPadded) {
				return (str + paddingString)
			} else {
				return (paddingString + str)
			}
		} else {
			return str
		}
	}

	let padLeft = (str, totalWidth, paddingChar) => {
		if (paddingChar !== null) {
			return pad(str, totalWidth, paddingChar, false)
		} else {
			return pad(str, totalWidth, ' ', false)
		}
	}
	let padRight = (str, totalWidth, paddingChar) => {
		if (paddingChar !== null) {
			return pad(str, totalWidth, paddingChar, true)
		} else {
			return pad(str, totalWidth, ' ', true)
		}
	}

	return { trim, pad, padLeft, padRight }
}

export default {
	install: function (Vue) {
		if (strHelper.installed) {
			return
		}
		strHelper.installed = true
		Vue.prototype.strHelper = strHelper()
	},

	instance: strHelper()
}



// WEBPACK FOOTER //
// ./src/helper/string.js